export default __webpack_public_path__ + "static/media/kl-08.7e68b80c.png";